import { Component, OnInit, inject } from "@angular/core";
import { LoggedInInfoService } from "../../../../services/loggedInInfo/logged-in-info.service";
import { NavigationService } from "../../../../services/navigation/navigation.service";
import { AuthService } from "@rn-platform/frontend-shared-feature-identity-auth";

@Component({
    selector: "app-rn-sidebar",
    templateUrl: "./rn-sidebar.component.html",
    styleUrls: ["./rn-sidebar.component.scss"],
    standalone: false
})
export class RnSidebarComponent implements OnInit {
  private navigationService = inject(NavigationService);
  private loggedInInfoService = inject(LoggedInInfoService);
  private authService = inject(AuthService);

  public showRNSupportItems: boolean;
  public isUserLoggedIn: boolean;

  ngOnInit(): void {
    this.authService.isLoggedIn().subscribe((b) => {
      this.isUserLoggedIn = b;
    });
    this.loggedInInfoService.LoggedInuserOrgConfig.subscribe((c) => {
      if (c) {
        this.showRNSupportItems = !c.DisallowRNSupport;
      }
    });
  }

  public launchDownloadSetupWizard(): void {
    this.navigationService.showDownloadSetupDialog(false);
  }
}
